<template>
    <form @submit.prevent="submitForm" id='MultipleItems'>
    <div class="mb-3">
      <label for="input-sku" class="form-label">
        Scan SKU
      </label>
      <input type="text" v-model="sku" class="form-control" id="input-transfer-sku" @keyup="validateSku">
    </div>

    <div class="mb-3">
      <label for="scanned-skus" class="form-label">
        Scanned SKUs
      </label>
      <ul class="list-group">
        <li :class="selectedSkus.includes(sku) ? 'list-group-item active' : 'list-group-item'" v-for="(sku, index) in scannedSkus">
          <div class="row">
            <div class="col-8" @click="selectSku(sku)">
              {{ sku }}
            </div>
            <div class="col-4 text-right">
              <button type="button" class="btn btn-default btn-sm">
                View More
              </button>
            </div>
          </div>
        </li>
        <li class="list-group-item" v-if="scannedSkus.length == 0">
          Nothing scanned yet
        </li>
      </ul>
    </div>

    <div class="row mb-3">
      <div class="col-6">
        <button type="button" class="btn btn-secondary btn-sm btn-clear-selected" @click.prevent="clearSelected" :disabled="!scannedSkus.length">
          Clear Selected
        </button>
      </div>
      <div class="col-6 text-right">
        <button type="button" class="btn btn-primary btn-sm btn-clear-all" @click.prevent="clearAll" :disabled="!scannedSkus.length">
          Clear All
        </button>
      </div>
    </div>

    <div class="mb-3">
      <label for="input-scan-bin" class="form-label">
        Scan Bin
      </label>
      <input type="inputScanBin" class="form-control" id="input-scan-bin">
    </div>

    <div class="d-grid gap-2 col-sm-6 mx-auto mt-4">
      <button type="submit" class="btn btn-success w-100 btn-finalize-receipt">
        Put Away Items
      </button>
    </div>

  </form>
</template>

<script>
  export default {
    name: 'Multiple',
    data() {
      return {
        sku : '',
        selectedSkus : [],
        scannedSkus : [],
      }
    },
    mounted() {
      console.log('csrf', document.querySelector('meta[name="csrf-token"]').getAttribute('content'))

    },
    methods: {
      clearSelected() {
        this.selectedSkus.forEach(sku => this.removeSku(sku))
        this.selectedSkus.splice(0, this.selectedSkus.length)
      },
      clearAll() {
        this.selectedSkus.splice(0, this.selectedSkus.length)
        this.scannedSkus.splice(0, this.scannedSkus.length)
      },
      selectSku(sku) {
        if ( this.selectedSkus.includes(sku) ) {
          this.selectedSkus.splice(this.selectedSkus.indexOf(sku), 1)
        } else {
          this.selectedSkus.push(sku)
        }
      },
      removeSku(sku) {
        this.scannedSkus.splice(this.scannedSkus.indexOf(sku), 1)
      },
      addSku(sku) {
        if ( sku ) {
          if ( this.scannedSkus.indexOf(sku) == -1 ) { //TODO: not working
            this.scannedSkus.push(sku)
          }
        }
      },
      validateSku(e) {
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
          e.preventDefault()
          this.addSku(this.sku)
          this.sku = ''
        }
      },
      submitForm() {
        const {
          sku,
          scannedSkus
        } = this

        this.$api.post('/api/power-scan/transfer-items-to-bin-location', {
          //_token : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          sku,
          scannedSkus
        }).then((response) => {
          console.log('Roman:', response)
        })

      }
    }
  }
</script>